<template>
  <div id="contenedor-infraestructura-listado-configuracion-subtipos-infraestructura">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop :listadoSubtiposInfraestructura="listadoSubtiposInfraestructura"> </desktop>
    </template>
    <template v-else>
      <desktop :listadoSubtiposInfraestructura="listadoSubtiposInfraestructura"></desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'InfraestructuraListadoConfiguracionTipoInfraestructura',
  props: {
    listadoSubtiposInfraestructura: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss"></style>
